import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import summaryStyles from '../../Pipeline/Summary.module.css';
import styles from './TestExecutionStatusSummary.module.css';
import { TestExecutionDashboardSummary } from '../interfaces/text-execution-dashboard.interface';

interface TestExecutionStatusSummaryProps {
  data: TestExecutionDashboardSummary[];
  className?: string;
  isLoading: boolean;
  isError: boolean;
}

interface StatusItem {
  label: string;
  value: number;
  status: string;
  iconClass: string;
}

const DASHBOARD_STATUSES: Array<{ status: string; label: string; iconClass: string }> = [
  { status: 'Running', label: 'Running', iconClass: summaryStyles.statusIconBlue },
  { status: 'Success', label: 'Successful', iconClass: summaryStyles.statusIconGreen },
  { status: 'Failure', label: 'Failure', iconClass: summaryStyles.statusIconRed },
  { status: 'Warning', label: 'Warning', iconClass: summaryStyles.statusIconOrange }
];

const TestExecutionStatusSummary = ({ data, className, isLoading, isError }: TestExecutionStatusSummaryProps) => {
  const statusItems: StatusItem[] = useMemo(() => {
    return DASHBOARD_STATUSES.map(({ status, label, iconClass }) => ({
      label,
      value: data.find((d) => d.status === status)?.total ?? 0,
      status,
      iconClass
    }));
  }, [data]);

  const header = (
    <div className={styles.header}>
      <div className={styles.title}>Overall Test Execution Summary</div>
      <span className={styles.subtitle}>All Product Lines</span>
    </div>
  );

  if (isLoading) {
    return (
      <div>
        {header}
        <div id="waiting" className="waiting hidden">
          <div className="message"></div>
          <div className="loading"></div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={`${styles.wrapper} ${className ?? ''}`}>
        {header}
        <div className={styles.loadingText}>Error while loading the overall test execution summary.</div>
      </div>
    );
  }

  return (
    <div className={`${styles.wrapper} ${className ?? ''}`}>
      {header}
      <div className={styles.row}>
        {statusItems.map((item) => (
          <div key={item.status} className={styles.kpi}>
            <div className={summaryStyles.kpiLabel}>
              Test Execution
              <Link to={`/automation-flows/test-orchestration/executions/${item.status}`} className={styles.testExecutionsLink}>
                <i className="icon icon-arrow-right" aria-hidden />
              </Link>
            </div>
            <div className={summaryStyles.kpiValue}>{item.value}</div>
            <div className={summaryStyles.kpiStatus}>
              <span className={`${summaryStyles.statusIcon} ${item.iconClass}`}></span>
              <span>{item.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestExecutionStatusSummary;
